module.exports = __webpack_public_path__ + "static/img/teacher_male.483b6ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teacher_male.png
// module id = 7xZd
// module chunks = 79